// extracted by mini-css-extract-plugin
export default {"container":"Fp-z","ratingLayout":"Gp-z","ratingLabel":"Hp-z","nonInteractiveRatingLabel":"Ip-z"};